import { __extends } from "tslib";
import BaseObserver from "../BaseObserver";
import EventTypes from "../EventTypes";
export var ChangeType;
(function (ChangeType) {
    ChangeType[ChangeType["HtmlLangAttribute"] = 0] = "HtmlLangAttribute";
})(ChangeType || (ChangeType = {}));
/**
 * LangChange
 * Knows how to detect when HTML lang changes
 * @todo - include listener: window.onlanguagechange to detect changes because
 * this will take into account multiple sources
 */
var LangChange = /** @class */ (function (_super) {
    __extends(LangChange, _super);
    function LangChange() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleChange = function (mutations) {
            var previousLangByType = LangChange.previousLangByType;
            var currentHtmlLang = _this.getLeadingHtmlLang();
            var changeType = ChangeType.HtmlLangAttribute;
            var prevHtmlLang = changeType in previousLangByType ? previousLangByType[changeType] : null;
            if (_this.isStarted && currentHtmlLang !== prevHtmlLang) {
                var event_1 = {
                    changeType: changeType,
                    current: currentHtmlLang,
                    previous: prevHtmlLang,
                    type: EventTypes.LangChange,
                };
                LangChange.previousLangByType[changeType] = currentHtmlLang;
                _this.callback(event_1);
            }
        };
        return _this;
    }
    LangChange.prototype.start = function () {
        _super.prototype.start.call(this);
        var htmlEl = document.querySelector("html");
        var htmlElObserver = new MutationObserver(this.handleChange);
        if (!LangChange.previousLangByType) {
            LangChange.previousLangByType = {};
        }
        htmlElObserver.observe(htmlEl, {
            attributeFilter: LangChange.langAttributes,
            attributes: true,
            characterData: false,
            childList: false,
        });
        this.htmlEl = htmlEl;
        this.htmlElObserver = htmlElObserver;
    };
    LangChange.prototype.stop = function () {
        _super.prototype.stop.call(this);
        if (this.htmlElObserver) {
            this.htmlElObserver.disconnect();
            this.htmlElObserver = null;
        }
    };
    LangChange.prototype.getLeadingHtmlLang = function () {
        var _this = this;
        var leadingAttributeWithValue = LangChange.langAttributes.find(function (attribute) { return !!_this.htmlEl.getAttribute(attribute); });
        return leadingAttributeWithValue;
    };
    LangChange.langAttributes = ["lang"];
    return LangChange;
}(BaseObserver));
export default LangChange;
//# sourceMappingURL=LangChange.js.map